/** @jsx jsx */
/* eslint-disable no-use-before-define */

import useSavedSearches from './use-saved-searches'
import {Flyout, mediaQueries, showModal, parseHtml} from '../../twd'
import {jsx} from '@emotion/core'

export default ({refresh, onSearch}) => {
    const { status, Loading, savedSearches } = useSavedSearches({refresh})

    return (
        <div
            data-name="global-search-saved-searches"
            className="col-xs-12 col-md-6" css={style}>
        <div className="text-bold">Saved Searches</div>
        <Loading status={status} spinner={false}>
        {
            savedSearches.map( (a,i) => (
                <div key={i}
                    data-name="global-search-saved-search"
                    className="auto-suggest-menu-item"
                    item={a}
                    onClick={() => onSearch(a)}>
                    <Flyout
                        trigger={['hover']}
                        showIcon={false}
                        isButton={false}
                        html={parseHtml(a.description)}
                        className='link-button'
                        labelStyle={{display:'inline-block'}}
                        trackMouseOnTip={false}
                        label={<span className="text-truncate">{a.description}</span>}
                    />
                </div>
            ))
        }

        <button
            data-name="global-search-saved-searches-view-all"
            className="btn btn-link" onClick={onViewAll}>View all</button>

        </Loading>
        </div>)
}

const style = {
    [mediaQueries.notXs]: {
        float:'left',
        paddingBottom:'100%',
        marginBottom:'-100%'
    }
}

const onViewAll = (e) => {
    showModal('manage-saved-searches', { source:e.target, })
}


// WEBPACK FOOTER //
// ./src/header/global-search/saved-searches.js